import {
  FETCH_DASHBOARD_STATS_REQUEST,
  FETCH_DASHBOARD_STATS_SUCCESS,
  FETCH_DASHBOARD_STATS_FAILURE,
  FETCH_APP_STORE_RATINGS_REQUEST,
  FETCH_APP_STORE_RATINGS_SUCCESS,
  FETCH_APP_STORE_RATINGS_FAILURE,
} from "../constants/ActionTypes";

const INITIAL_STATE = {
  stats: {
    content_statistics: {
      sessions: 0,
      quick_taps: 0,
      challenges: 0,
      series: 0,
      categories: 0,
      subcategories: 0,
    },
    most_played: {
      session: null,
      quick_tap: null,
    },
    completed_meditations: {
      total: 0,
      regular_sessions: 0,
      quick_tap_sessions: 0,
    },
    active_users: 0,
  },
  appStore: {
    apple: {
      average_rating: 0,
      five_star_count: 0,
      total_reviews: 0,
      rating_counts: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
      reviews: [],
    },
    google: {
      average_rating: 0,
      five_star_count: 0,
      total_reviews: 0,
      total_reviews_display: null, // Approximate display string (e.g., "11.5K")
      rating_counts: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
      reviews: [],
    },
  },
  // Separate loading states to prevent race conditions
  loadingStats: false,
  loadingAppStore: false,
  error: null,
};

export default function dashboardReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_DASHBOARD_STATS_REQUEST:
      return {
        ...state,
        loadingStats: true,
        error: null,
      };

    case FETCH_DASHBOARD_STATS_SUCCESS:
      return {
        ...state,
        loadingStats: false,
        stats: {
          // FIX: Use nullish coalescing (??) instead of logical OR (||) 
          // to allow valid zero values to be set instead of falling back to stale state
          content_statistics: action.payload.content_statistics ?? state.stats.content_statistics,
          most_played: action.payload.most_played ?? state.stats.most_played,
          completed_meditations: action.payload.completed_meditations ?? state.stats.completed_meditations,
          active_users: action.payload.active_users ?? state.stats.active_users,
        },
        error: null,
      };

    case FETCH_DASHBOARD_STATS_FAILURE:
      return {
        ...state,
        loadingStats: false,
        error: action.payload,
      };

    case FETCH_APP_STORE_RATINGS_REQUEST:
      return {
        ...state,
        loadingAppStore: true,
      };

    case FETCH_APP_STORE_RATINGS_SUCCESS:
      return {
        ...state,
        loadingAppStore: false,
        appStore: {
          // FIX: Use nullish coalescing (??) instead of logical OR (||)
          // to allow valid zero values in ratings to be set
          apple: action.payload.apple ?? state.appStore.apple,
          google: action.payload.google ?? state.appStore.google,
        },
      };

    case FETCH_APP_STORE_RATINGS_FAILURE:
      return {
        ...state,
        loadingAppStore: false,
        // Don't set error for app store ratings failure - graceful degradation
      };

    default:
      return state;
  }
}
